import { render } from "./OtpVerify.vue?vue&type=template&id=15a235ca&scoped=true"
import script from "./OtpVerify.vue?vue&type=script&lang=js"
export * from "./OtpVerify.vue?vue&type=script&lang=js"

import "./OtpVerify.vue?vue&type=style&index=0&id=15a235ca&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a235ca"]])

export default __exports__